import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as constants from '../common/constants';
import * as errorCodes from '../common/errorCodes';
import * as loginactions from '../loginpages/actionCreators';
import { TFA_STATE } from '../loginpages/actionCreators';
import { TFA_CLEAR_ERROR, TFA_SET_ERROR } from './actionCreators';
import LoginTemplateTfaHelpPages from '../loginpages/LoginTemplateTfaHelpPages';
import { useJspVariables, useNavigation, useAppContext, useAuth, useDebugRender } from '../hooks';
import { IceIcon, PageContainer, PageHeader } from '../components';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
const PageEmailPasscode = () => {
    useDebugRender('PageEmailPasscode');
    const dispatch = useDispatch();
    const { jspVariables, launcher, panelStyle } = useJspVariables();
    const { toPageLogin } = useNavigation({ launcher });
    const { getApp, getLabelFromJspVariables } = useAppContext(jspVariables);

    const { authenticatedUser } = useAuth();
    const userName = authenticatedUser?.authenticatedUser || '';
    const tfaError = useSelector(state => state.tfaReducer.tfaError);

    const [password, setPassword] = useState('');
    const [tfaPasscode, setTfaPasscode] = useState('');
    const [mersOrganization] = useState('');
    const [rememberMe] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [fieldErrors, setFieldErrors] = useState({});

    useEffect(() => {
        dispatch({ type: TFA_STATE, data: { required: false } });
        return () => {
            dispatch({ type: TFA_CLEAR_ERROR });
        };
    }, []);

    const onPasswordChange = (event) => {
        setPassword(event.target.value);
        if (fieldErrors.password) setFieldErrors(prev => ({ ...prev, password: '' }));
    };

    const pageEmailPasscodeSubmit = async () => {
        const errors = {};
        if (!userName) errors.userName = errorCodes.MSG_FIELD_REQUIRED();
        if (!password) errors.password = errorCodes.MSG_FIELD_REQUIRED();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) return;

        dispatch({ type: TFA_CLEAR_ERROR });
        try {
            await loginactions.authAndSendCodeTo2FAEmail(userName, getApp(), password, { tfaPasscode, mersOrganization, rememberMe });
            setOtpSent(true);
            setTfaPasscode('');
        } catch (resp) {
            dispatch({ type: TFA_SET_ERROR, data: { message: resp.message, code: resp.code } });
        }
    };

    return (
        <PageContainer id="pageEmailPassCode" dataAutomationId="page_email_pass_code">
            <Box sx={panelStyle}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Link component="button" type="button" onClick={toPageLogin}>{getLabelFromJspVariables('action_page_back')}</Link>
                </Box>
                <IceIcon launcher={launcher} />
                <PageHeader dataAutomationId="email_passcode_header">{getLabelFromJspVariables('title_email_2fa_otp')}</PageHeader>
                {tfaError && <Alert id="pageEmailPasscodeAlert" data-automation-id="page_email_passcode_alert" severity="error" sx={{ mb: 1 }}>{tfaError.message}</Alert>}
                {otpSent && <Alert severity="success" aria-live="polite" sx={{ mb: 1 }}>{getLabelFromJspVariables('tfa_passcode_sent_to_email')}</Alert>}
                <Box id="formEmailPassCodeLogin" data-automation-id="form_email_pass_code_login">
                    <Box>{getLabelFromJspVariables('forgot_device_receive')}</Box>
                    <Box>{getLabelFromJspVariables('enter_password_receive_otp')}</Box>
                    <LoginTemplateTfaHelpPages
                        userName={userName}
                        userNameDisabled={!!userName}
                        password={password}
                        userNameLabel={getLabelFromJspVariables('label_userid')}
                        onUserNameChange={() => {}}
                        onPasswordChange={onPasswordChange}
                        userNameError={fieldErrors.userName}
                        passwordError={fieldErrors.password}
                    />
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button variant="contained" fullWidth
                            onClick={pageEmailPasscodeSubmit}
                            data-automation-id="email_passcode_send_otp_btn">
                            {getLabelFromJspVariables('action_send_otp')}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </PageContainer>
    );
};

export default PageEmailPasscode;
